/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 20.04.2016.
 */

import React, {Component, PropTypes} from 'react';

import {StubFunc} from '../../utils';

class BannersSliderControls extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {

    return (
      <div>
        <a className="adv-slider-arr slider-prev ico ico-arr-prev hover" onClick={this.props.onSlideLeft}></a>
        <a className="adv-slider-arr slider-next ico ico-arr-next hover" onClick={this.props.onSlideRight}></a>
      </div>
    );
  }
}

BannersSliderControls.propTypes = {
  onSlideRight: PropTypes.func.isRequired,
  onSlideLeft: PropTypes.func.isRequired
};

BannersSliderControls.defaultProps = {
  onSlideRight: StubFunc.bind(this, 'onSlideRight'),
  onSlideLeft: StubFunc.bind(this, 'onSlideLeft')
};

export default BannersSliderControls;



// WEBPACK FOOTER //
// ./src/components/BannersSlider/banners-slider-controls.js